import axios from 'axios';
import constants from "../constants";
import {getHeaders} from './global';


function createTask(workspace_id, payload){
    return axios.post(
        constants.API_BASE_URL + "workspaces/" + workspace_id + "/tasks/",
        payload,
        getHeaders()
    )
}

function getTasks(workspace_id){
    return axios.get(
        constants.API_BASE_URL + "workspaces/" + workspace_id + "/tasks/?status!=2&page_size=999999",
        getHeaders()
    )
}

function getTasksCompleted(workspace_id){
    return axios.get(
        constants.API_BASE_URL + "workspaces/" + workspace_id + "/tasks/?status=2&page_size=999999",
        getHeaders()
    )
}

function getTask(workspace_id, task_id){
    return axios.get(
        constants.API_BASE_URL + "workspaces/" + workspace_id + "/tasks/" + task_id + "/",
        getHeaders()
    )
}

function updateTask(workspace_id, task_id, payload){
    return axios.patch(
        constants.API_BASE_URL + "workspaces/" + workspace_id + "/tasks/" + task_id + "/",
        payload,
        getHeaders()
    )
}

function getTaskComments(workspace_id, task_id){
    return axios.get(
        constants.API_BASE_URL + "workspaces/" + workspace_id + "/tasks/" + task_id + "/comments/",
        getHeaders()
    )
}

function createTaskComment(workspace_id, task_id, payload){
    return axios.post(
        constants.API_BASE_URL + "workspaces/" + workspace_id + "/tasks/" + task_id + "/comments/",
        payload,
        getHeaders()
    )
}

function translateTaskStatus(status_id){
    let text = ""
    switch(status_id) {
        case 0:
          text = "Pending";
          break;
        case 1:
          text = "Started";
          break;
        case 2:
          text = "Completed";
          break;
        default:
          text = "Unknown";
    }
    return text
}

export {
    getTasks,
    createTask,
    getTask,
    getTaskComments,
    updateTask,
    getTasksCompleted,
    createTaskComment,
    translateTaskStatus,
}